/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SortOrder = {
    asc: 'asc',
    desc: 'desc'
} as const;
export type SortOrder = typeof SortOrder[keyof typeof SortOrder];


export function instanceOfSortOrder(value: any): boolean {
    for (const key in SortOrder) {
        if (Object.prototype.hasOwnProperty.call(SortOrder, key)) {
            if (SortOrder[key as keyof typeof SortOrder] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SortOrderFromJSON(json: any): SortOrder {
    return SortOrderFromJSONTyped(json, false);
}

export function SortOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortOrder {
    return json as SortOrder;
}

export function SortOrderToJSON(value?: SortOrder | null): any {
    return value as any;
}

export function SortOrderToJSONTyped(value: any, ignoreDiscriminator: boolean): SortOrder {
    return value as SortOrder;
}

